module.exports = __webpack_public_path__ + "static/img/loyola.d384cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loyola.png
// module id = 16
// module chunks = 0